import React from 'react';
import './UnderlinedText.css';

/**
 * UnderlinedText component
 * Renders text with optional decorative underline and custom text color
 *
 * @param {React.ReactNode} children - The text content
 * @param {string} color - 'yellow' or 'blue' for underline color (default: 'yellow')
 * @param {string} textColor - Custom text color (CSS color value)
 * @param {boolean} showUnderline - Whether to show the underline (default: true)
 * @param {string} className - Additional CSS classes
 */
const UnderlinedText = ({ children, color = 'yellow', textColor, showUnderline = true, className = '' }) => {
  const contentStyle = textColor ? { color: textColor } : undefined;

  return (
    <span className={`underlined-text ${className}`}>
      {showUnderline && (
        <span
          className={`underlined-text__decoration underlined-text__decoration--${color}`}
          aria-hidden="true"
        />
      )}
      <span className="underlined-text__content" style={contentStyle}>{children}</span>
    </span>
  );
};

export default UnderlinedText;
